module.exports = "/_next/static/images/illustration-609acae254564167044cc28773bf84ab.svg";